var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.772 10.656L19.404 6.551C18.995 5.324 17.852 4.5 16.559 4.5H7.441C6.148 4.5 5.005 5.324 4.596 6.551L3.228 10.656C2.508 10.959 2 11.671 2 12.5V17.5C2 18.253 2.423 18.902 3.039 19.243C3.026 19.309 3 19.369 3 19.438V21.5C3 22.053 3.447 22.5 4 22.5H5C5.553 22.5 6 22.053 6 21.5V19.5H18V21.5C18 22.053 18.447 22.5 19 22.5H20C20.553 22.5 21 22.053 21 21.5V19.438C21 19.369 20.974 19.308 20.961 19.243C21.577 18.902 22 18.253 22 17.5V12.5C22 11.671 21.492 10.959 20.772 10.656ZM4 17.5V12.5H20L20.002 17.5H4ZM7.441 6.5H16.558C16.989 6.5 17.371 6.774 17.507 7.184L18.613 10.5H5.387L6.492 7.184C6.629 6.774 7.011 6.5 7.441 6.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16.5C7.32843 16.5 8 15.8284 8 15C8 14.1716 7.32843 13.5 6.5 13.5C5.67157 13.5 5 14.1716 5 15C5 15.8284 5.67157 16.5 6.5 16.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.5C18.3284 16.5 19 15.8284 19 15C19 14.1716 18.3284 13.5 17.5 13.5C16.6716 13.5 16 14.1716 16 15C16 15.8284 16.6716 16.5 17.5 16.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.ce4652afdf8959831219116275edd5c2.svg";
export { ForwardRef as ReactComponent };